import { useEffect, useState } from 'react';
import { getApiUrl, API_ENDPOINTS } from '../config/apiConfig';

const SEO = ({ 
  title = '',
  description = '',
  keywords = '',
  image = '',
  url = '',
  type = 'website'
}) => {
  const [siteSettings, setSiteSettings] = useState(null);

  useEffect(() => {
    // Site ayarlarını çek
    const fetchSiteSettings = async () => {
      try {
        const response = await fetch(getApiUrl(API_ENDPOINTS.GET_PUBLIC_SETTINGS));
        if (response.ok) {
          const data = await response.json();
          setSiteSettings(data);
        }
      } catch (error) {
        console.error('Site ayarları yüklenirken hata:', error);
      }
    };
    fetchSiteSettings();
  }, []);

  useEffect(() => {
    if (!siteSettings) return;

    const siteTitle = siteSettings.site_title || 'CineGlass';
    
    // SEO ayarlarını çek - eğer SEO ayarları yoksa site ayarlarından kullan
    const seoSiteTitle = siteSettings.seo_site_title || siteSettings.site_title || '';
    const seoSiteDescription = siteSettings.seo_site_description || siteSettings.site_description || '';
    const seoSiteKeywords = siteSettings.seo_site_keywords || siteSettings.site_keywords || '';
    const seoHomeTitle = siteSettings.seo_home_title || siteSettings.seo_site_title || siteSettings.site_title || '';
    const seoHomeDescription = siteSettings.seo_home_description || siteSettings.seo_site_description || siteSettings.site_description || '';
    const seoHomeKeywords = siteSettings.seo_home_keywords || siteSettings.seo_site_keywords || siteSettings.site_keywords || '';
    const seoOgImage = siteSettings.seo_og_image || '';
    const seoAuthor = siteSettings.seo_author || siteTitle;
    const seoLanguage = siteSettings.seo_language || 'tr';
    const seoRobots = siteSettings.seo_robots || 'index, follow';
    const seoCanonicalUrl = siteSettings.seo_canonical_url || '';
    
    // Title belirleme - önce prop, sonra SEO ayarları, sonra varsayılan
    let finalTitle = title;
    if (!finalTitle || finalTitle.trim() === '') {
      // Ana sayfa ise özel SEO title kullan
      if (window.location.pathname === '/') {
        finalTitle = seoHomeTitle || `${siteTitle} - Türkçe Dublaj ve Altyazılı Film ve Dizi İzle`;
      } else {
        finalTitle = seoSiteTitle || `${siteTitle} - Türkçe Dublaj ve Altyazılı Film ve Dizi İzle`;
      }
    }
    
    // Site adı title'da yoksa ve prop'tan geliyorsa ekle (site ayarlarından geliyorsa ekleme)
    if (title && title.trim() !== '' && !finalTitle.includes(siteTitle)) {
      finalTitle = `${finalTitle} - ${siteTitle}`;
    }
    
    document.title = finalTitle;

    // Meta description - önce prop, sonra SEO ayarları, sonra site ayarları
    let finalDescription = description;
    if (!finalDescription || finalDescription.trim() === '') {
      if (window.location.pathname === '/') {
        finalDescription = seoHomeDescription || 'CineGlass ile en yeni filmler ve dizileri Türkçe dublaj ve altyazılı olarak izleyin.';
      } else {
        finalDescription = seoSiteDescription || 'CineGlass ile en yeni filmler ve dizileri Türkçe dublaj ve altyazılı olarak izleyin.';
      }
    }
    
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', finalDescription);

    // Meta keywords - önce prop, sonra SEO ayarları, sonra site ayarları
    let finalKeywords = keywords;
    if (!finalKeywords || finalKeywords.trim() === '') {
      if (window.location.pathname === '/') {
        finalKeywords = seoHomeKeywords || 'film izle, dizi izle, türkçe dublaj, türkçe altyazı';
      } else {
        finalKeywords = seoSiteKeywords || 'film izle, dizi izle, türkçe dublaj, türkçe altyazı';
      }
    }
    
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', finalKeywords);

    // Open Graph tags
    const finalImage = image || seoOgImage || '';
    const finalUrl = url || seoCanonicalUrl || window.location.href;
    
    const ogTags = [
      { property: 'og:title', content: finalTitle },
      { property: 'og:description', content: finalDescription },
      { property: 'og:type', content: type },
      { property: 'og:url', content: finalUrl },
      { property: 'og:site_name', content: siteTitle },
      { property: 'og:locale', content: seoLanguage === 'tr' ? 'tr_TR' : 'en_US' },
    ];

    if (finalImage) {
      ogTags.push({ property: 'og:image', content: finalImage });
    }

    ogTags.forEach(tag => {
      let metaTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', tag.property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', tag.content);
    });

    // Twitter Card tags
    const twitterCardType = siteSettings.seo_twitter_card || 'summary_large_image';
    const twitterTags = [
      { name: 'twitter:card', content: twitterCardType },
      { name: 'twitter:title', content: finalTitle },
      { name: 'twitter:description', content: finalDescription },
    ];

    if (finalImage) {
      twitterTags.push({ name: 'twitter:image', content: finalImage });
    }

    twitterTags.forEach(tag => {
      let metaTag = document.querySelector(`meta[name="${tag.name}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('name', tag.name);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', tag.content);
    });

    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', finalUrl);

    // Favicon (Site Icon) - site_icon ayarından al
    const siteIcon = siteSettings.site_icon || '';
    if (siteIcon) {
      // Mevcut favicon link'lerini bul ve güncelle
      let favicon = document.querySelector('link[rel="icon"]');
      if (!favicon) {
        favicon = document.createElement('link');
        favicon.setAttribute('rel', 'icon');
        document.head.appendChild(favicon);
      }
      favicon.setAttribute('href', siteIcon);

      // Apple touch icon için de güncelle
      let appleTouchIcon = document.querySelector('link[rel="apple-touch-icon"]');
      if (!appleTouchIcon) {
        appleTouchIcon = document.createElement('link');
        appleTouchIcon.setAttribute('rel', 'apple-touch-icon');
        document.head.appendChild(appleTouchIcon);
      }
      appleTouchIcon.setAttribute('href', siteIcon);
    }

    // Author meta tag
    let metaAuthor = document.querySelector('meta[name="author"]');
    if (!metaAuthor) {
      metaAuthor = document.createElement('meta');
      metaAuthor.setAttribute('name', 'author');
      document.head.appendChild(metaAuthor);
    }
    metaAuthor.setAttribute('content', seoAuthor);

    // Language meta tag
    let metaLanguage = document.querySelector('meta[http-equiv="content-language"]');
    if (!metaLanguage) {
      metaLanguage = document.createElement('meta');
      metaLanguage.setAttribute('http-equiv', 'content-language');
      document.head.appendChild(metaLanguage);
    }
    metaLanguage.setAttribute('content', seoLanguage);

    // Robots meta tag
    let metaRobots = document.querySelector('meta[name="robots"]');
    if (!metaRobots) {
      metaRobots = document.createElement('meta');
      metaRobots.setAttribute('name', 'robots');
      document.head.appendChild(metaRobots);
    }
    metaRobots.setAttribute('content', seoRobots);

    // Geo tags (eğer varsa)
    if (siteSettings.seo_geo_region) {
      let metaGeoRegion = document.querySelector('meta[name="geo.region"]');
      if (!metaGeoRegion) {
        metaGeoRegion = document.createElement('meta');
        metaGeoRegion.setAttribute('name', 'geo.region');
        document.head.appendChild(metaGeoRegion);
      }
      metaGeoRegion.setAttribute('content', siteSettings.seo_geo_region);
    }

    if (siteSettings.seo_geo_placename) {
      let metaGeoPlacename = document.querySelector('meta[name="geo.placename"]');
      if (!metaGeoPlacename) {
        metaGeoPlacename = document.createElement('meta');
        metaGeoPlacename.setAttribute('name', 'geo.placename');
        document.head.appendChild(metaGeoPlacename);
      }
      metaGeoPlacename.setAttribute('content', siteSettings.seo_geo_placename);
    }

    if (siteSettings.seo_geo_position) {
      let metaGeoPosition = document.querySelector('meta[name="geo.position"]');
      if (!metaGeoPosition) {
        metaGeoPosition = document.createElement('meta');
        metaGeoPosition.setAttribute('name', 'geo.position');
        document.head.appendChild(metaGeoPosition);
      }
      metaGeoPosition.setAttribute('content', siteSettings.seo_geo_position);
    }

    // Revisit-after meta tag
    if (siteSettings.seo_revisit_after) {
      let metaRevisit = document.querySelector('meta[name="revisit-after"]');
      if (!metaRevisit) {
        metaRevisit = document.createElement('meta');
        metaRevisit.setAttribute('name', 'revisit-after');
        document.head.appendChild(metaRevisit);
      }
      metaRevisit.setAttribute('content', siteSettings.seo_revisit_after);
    }

    // Distribution meta tag
    if (siteSettings.seo_distribution) {
      let metaDistribution = document.querySelector('meta[name="distribution"]');
      if (!metaDistribution) {
        metaDistribution = document.createElement('meta');
        metaDistribution.setAttribute('name', 'distribution');
        document.head.appendChild(metaDistribution);
      }
      metaDistribution.setAttribute('content', siteSettings.seo_distribution);
    }

    // Rating meta tag
    if (siteSettings.seo_rating) {
      let metaRating = document.querySelector('meta[name="rating"]');
      if (!metaRating) {
        metaRating = document.createElement('meta');
        metaRating.setAttribute('name', 'rating');
        document.head.appendChild(metaRating);
      }
      metaRating.setAttribute('content', siteSettings.seo_rating);
    }

  }, [title, description, keywords, image, url, type, siteSettings]);

  return null;
};

export default SEO;

